import { BaseEntityPropsInitial, IBaseEntityProps } from '../BaseEntity/IBaseEntityProps';
import { DeliveryDriverMonitoringDTO, DriverMonitoringHelperProps, DriverMonitoringHelperPropsInitial } from './IHelperProps';

export type IDriverMonitoringProps = IBaseEntityProps<DeliveryDriverMonitoringDTO, DriverMonitoringHelperProps>;

export const DriverMonitoringPropsInitial: IDriverMonitoringProps = { 
    ...BaseEntityPropsInitial,
    DataHelper: DriverMonitoringHelperPropsInitial
};
